import { prepareLink, PrepareLinkParams } from '@gem/utils';

import { getLocation, getNavigate } from './refs';

/**
 * @deprecated Use 'useNavigate' hook from react router library
 */
export function navigateTo(data: Partial<PrepareLinkParams> = {}): void {
  const navigate = getNavigate();
  const location = getLocation();

  if (navigate && location) {
    const link = prepareLink({ ...data, location });
    navigate(`${link.pathname}${link.search}`, { state: link.state });
  }
}
